import React from 'react';
import { RouteComponentProps } from 'react-router-dom';

import { useGetQuery } from 'api/useGetQuery';
import { ENDPOINTS } from 'api/endpoints';
import { ProductUploadLookup } from 'types/ProductUploadLookup';
import { FormInitialData, NullFormInitialData } from 'types/FormInitialData';
import Form from './Form';
import { useDataEnvironment } from 'contexts/DataEnvironmentContext';
import months from 'utils/months';
import { LoadingIndicator } from 'components/LoadingIndicator/LoadingIndicator';

type MatchParams = {
  id: string;
};

type Props = RouteComponentProps<MatchParams>;

const EditForm: React.FC<Props> = (props: Props) => {
  const id = props.match.params.id;
  const [dataEnvironment] = useDataEnvironment();
  const {
    isFetching: isLoadingProductUpload,
    data: productUploadData,
  } = useGetQuery<ProductUploadLookup>(ENDPOINTS.productUpload(dataEnvironment!.id, id));

  if (isLoadingProductUpload) {
    return <LoadingIndicator />;
  }

  let initialData: FormInitialData = NullFormInitialData;

  if (productUploadData) {
    const startDate = new Date(productUploadData.startDate);
    const endDate = new Date(productUploadData.endDate);
    initialData = {
      startMonth: { value: startDate.getMonth(), label: months[startDate.getMonth()] },
      startYear: { value: startDate.getFullYear(), label: startDate.getFullYear().toString() },
      name: productUploadData.name,
      endMonth: { value: endDate.getMonth(), label: months[endDate.getMonth()] },
      endYear: { value: endDate.getFullYear(), label: endDate.getFullYear().toString() },
      firmName: { id: productUploadData.firmNamePropertyDefinitionId, label: '' },
      productName: { id: productUploadData.productNamePropertyDefinitionId, label: '' },
      assets: productUploadData.assets,
    };
  }

  return <Form productUploadFormData={initialData} id={id} />;
};

export default EditForm;
